import * as PropTypes from 'prop-types';
import * as React from 'react';
import Pill from './pill';
import UserCurrency from '../../../shared/user_currency';

const PriceSearchPills = ({ indexParams }) => {
  const priceMin = indexParams.priceMin;
  const priceMax = indexParams.priceMax;
  if (indexParams.free) {
    return <Pill value={I18n.t('digitalListing.free')} onClick={() => indexParams.toggleFree()} />;
  }

  const pills = [];
  if (indexParams.showAllPaid) {
    pills.push(<Pill
      key="paid"
      value={I18n.t('digitalListing.paid')}
      onClick={() => indexParams.togglePaid()}
    />);
  } else if (priceMin) {
    pills.push(<Pill
      key="priceMin"
      value={
          I18n.t('digitalListing.priceMin', {
            currency: UserCurrency.symbol,
            priceMin,
          })
        }
      onClick={() => indexParams.changePriceFilter({ priceMin: null })}
    />);
  }
  if (priceMax) {
    pills.push(<Pill
      key="priceMax"
      value={
          I18n.t('digitalListing.priceMax', {
            currency: UserCurrency.symbol,
            priceMax,
          })
        }
      onClick={() => indexParams.changePriceFilter({ priceMax: null })}
    />);
  }
  if (pills.length) {
    return <span>{pills}</span>;
  }
  return null;
};

PriceSearchPills.propTypes = {
  indexParams: PropTypes.object.isRequired,
};

export default PriceSearchPills;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/search_pills/price_search_pills.jsx